import DashboardLayout from "../../components/Layout/DashboardLayout";
import ApplyIncentiveClaimForm from "../../components/User/ApplyIncentiveClaimForm";

const ApplyIncentiveClaimApplication = () => {
  return (
    <DashboardLayout pageTitle="Apply for Incentive Claim">
      <ApplyIncentiveClaimForm />
    </DashboardLayout>
  );
};

export default ApplyIncentiveClaimApplication;
